import { useEffect, useState } from "react";
import {
  HMSNotificationTypes,
  useHMSNotifications,
} from "@100mslive/react-sdk";
import { PARTICIPANT_ROLES } from "@circle-react/helpers/liveStreamRoomHelpers";
import type { ProviderRoleChangeNotification } from "../types";

export const useHMSRoleChangeNotification =
  (): ProviderRoleChangeNotification => {
    const [hasRoleChangedToModerator, setHasRoleChangedToModerator] =
      useState(false);
    const notification = useHMSNotifications(HMSNotificationTypes.ROLE_UPDATED);
    const peer = notification?.data;
    const hideModeratorNotification = () => setHasRoleChangedToModerator(false);
    useEffect(() => {
      if (!notification) {
        return;
      }
      if (
        peer &&
        peer.isLocal &&
        peer.roleName === PARTICIPANT_ROLES.MODERATOR
      ) {
        setHasRoleChangedToModerator(true);
      }
    }, [notification]);
    return {
      roleChangedToModerator: hasRoleChangedToModerator,
      hideModeratorNotification,
    };
  };
